import { api } from "./api/client.js";

// Port of store/actions/settings/user_settings.tsx + reducers/settings/user_settings — the
// per-user email-notification preferences behind the header's settings dialog.
//
// GET  /ui/user-settings -> { sendEmailOnDeposit, sendEmailOnWithdrawal, sendEmailOnInvoicePayment }
// POST /ui/user-settings <- the same three booleans
// Both are client-scoped (React sent `clientId`, and the transport sends X-Client-Id regardless),
// so the settings follow whichever client is active in the header.

const URI = "/ui/user-settings";

export const DEFAULT_USER_SETTINGS = Object.freeze({
  sendEmailOnWithdrawal: false,
  sendEmailOnDeposit: false,
  sendEmailOnInvoicePayment: false,
});

// The checkboxes, in the order and with the labels React rendered them.
export const NOTIFICATION_SETTINGS = Object.freeze([
  { key: "sendEmailOnWithdrawal", labelKey: "withdrawals" },
  { key: "sendEmailOnDeposit", labelKey: "deposits" },
  { key: "sendEmailOnInvoicePayment", labelKey: "invoice_payments" },
]);

// `sendEmailOnInvoicePayment` is an Option on the backend, so it can come back absent or null on an
// older row; an unchecked box is the safe reading of "not set". Anything else the endpoint might
// grow is dropped, so a stray field can never be echoed back on save.
export const normalizeUserSettings = (response) =>
  Object.fromEntries(
    Object.keys(DEFAULT_USER_SETTINGS).map((key) => [key, response?.[key] === true]),
  );

// The POST body is exactly the endpoint's UserSettingsJson — no more, no less.
export const userSettingsPayload = normalizeUserSettings;

export const fetchUserSettings = (client = api) =>
  client.get(URI, { clientId: true }).then(normalizeUserSettings);

// The api client throws on a non-2xx, so a failed save reaches the caller instead of being
// swallowed (React popped a SweetAlert from deep inside the transport).
export const saveUserSettings = (settings, client = api) =>
  client.post(URI, userSettingsPayload(settings), { clientId: true });
